import type { UserAPI } from '@sydle/ui-api';
import { DefaultRestService, getAPI } from '@sydle/ui-api';
import { getRouter, navigateToPath, reloadPageContent } from '@sydle/ui-utils';
import navbarStore from '../components/navbar/navbar.store';
import appStore from '../global/app.store';
import { getOrganizationConfig, getServiceDeskConfig } from '../models/serviceDeskConfig';
import { OneAPIHelper } from '../utils/api/one.api';
import { pushAlert } from './alert.utils';
import { ENV } from './env.utils';
import { translation } from './translation.utils';

export async function login(): Promise<void> {
  if (OneAPIHelper.isLoggedIn()) {
    reload();
    navbarStore.state.isLoggedIn = true;
    localStorage.setItem('isLoggedIn', 'true');

    // Notify chat that user did change
    window.postMessage(
      JSON.stringify({
        subject: 'userDidChange',
        body: {},
      }),
      '*',
    );

    pushAlert({ text: translation('LOGIN_SUCCESSFULLY', 'Login successfully performed'), type: 'INFO' });
  }
}

export async function logout(goToHome = true): Promise<void> {
  if (appStore.get('hasLogoutTimeoutId')) {
    appStore.set('hasLogoutTimeoutId', false);
    clearTimeout(appStore.get('logoutTimeoutId'));
  }

  const portal = getServiceDeskConfig();
  const disableLogoutRedirectCustomAuth = portal?.auth?.disableLogoutRedirectCustomAuth || false;
  const authenticator = await getAuthenticator();
  let logoutResponse: any;
  if (authenticator?.hasLogout && authenticator?.getLogoutUrl && !disableLogoutRedirectCustomAuth) {
    logoutResponse = await new DefaultRestService().post({
      addBaseUrl: false,
      url: authenticator.getLogoutUrl,
      headers: ENV.getHeaders(),
      addUserTokenOnHeader: true,
    });
  }

  await getAPI<UserAPI>('userAPI')?.logout();

  if (logoutResponse?.data?.url) {
    window.location.href = logoutResponse.data.url;
  } else {
    reload(goToHome);
    navbarStore.state.isLoggedIn = false;
    localStorage.setItem('isLoggedIn', 'false');
  }

  // Notify chat that user did change
  window.postMessage(
    JSON.stringify({
      subject: 'userDidChange',
      body: {},
    }),
    '*',
  );
}

async function getAuthenticator() {
  const orgConfig = await getOrganizationConfig();
  const authenticatorsConfig = orgConfig?.authenticatorsConfig;

  if (authenticatorsConfig) {
    const user = getAPI<UserAPI>('userAPI')?.getUser();
    const authenticatorId = user?.accessToken?.payload?.authenticatorId;

    return authenticatorsConfig.find((el) => el.authenticatorId === authenticatorId);
  }
  return null;
}

export function reload(goToHome = false): void {
  const location = getRouter()?.location;
  if (goToHome && location?.route?.path !== '/home') {
    navigateToPath('home');
  } else {
    reloadPageContent();
  }
}
